import { v4 as uuidv4 } from 'uuid';

export const FILTER_TYPE = 'Filter';
export const AGGREGATE_TYPE = 'Aggregate';
export const OPERATION_TYPE = 'Operation';
export const SOURCE_TYPE = 'Source';
export const SAVE_TRANSFORM_TYPE = 'Save';
export const ROUND_TYPE = 'Round';
export const JOIN_TYPE = 'Join'
export const SPECIAL_VT_TRUE_UP = 'SpecialVTTrueUp'

export const ALL_CONST_DETAILS = [FILTER_TYPE, AGGREGATE_TYPE, OPERATION_TYPE, SOURCE_TYPE, JOIN_TYPE];

export const FILTER_CONTAINS = 'Contains';
export const FILTER_NOT_CONTAINS = 'Not Contains';
export const FILTER_EQUALS = 'Equals';
export const FILTER_NOT_EQUALS = 'Not Equals';
export const FILTER_STARTS_WITH = 'Starts With';
export const FILTER_ENDS_WITH = 'Ends With';
export const FILTER_LESS_THAN = '<';
export const FILTER_LESS_THAN_EQUAL = '<=';
export const FILTER_GREATER_THAN = '>';
export const FILTER_GREATER_THAN_EQUAL = '>=';

export const OPERATION_ADD = 'Add';
export const OPERATION_SUB = 'Subtract';
export const OPERATION_MULT = 'Multiply';
export const OPERATION_DIV = 'Divide';

export const AGGREGATE_SUM = 'Sum';
export const AGGREGATE_COUNT = 'Count';

export const OPERATION_TYPES = [OPERATION_ADD, OPERATION_SUB, OPERATION_MULT, OPERATION_DIV];

export const AGGREGATE_TYPES = [AGGREGATE_SUM, AGGREGATE_COUNT];

export const FILTER_TYPES = [FILTER_CONTAINS, FILTER_NOT_CONTAINS, FILTER_EQUALS, FILTER_NOT_EQUALS, FILTER_STARTS_WITH,
  FILTER_ENDS_WITH, FILTER_LESS_THAN, FILTER_LESS_THAN_EQUAL, FILTER_GREATER_THAN, FILTER_GREATER_THAN_EQUAL];

export class Filter {
  constructor(columnName, operation, arg) {
    this.column_name = columnName;
    this.operation = operation;
    this.arg = arg;
    this.calc_type = FILTER_TYPE;
  }
}

export class Aggregate {

  constructor(groupColumnName, columnName, operation) {
    if (groupColumnName === undefined) {
      this.group_column_name = 'None';
    } else {
      this.group_column_name = groupColumnName;
    }
    this.column_name = columnName;
    this.operation = operation;
    this.calc_type = AGGREGATE_TYPE;
  }
}

export class Operation {
  constructor(item0, item1, operation, outputTable, outputColumn) {
    this.item0 = item0;
    this.item1 = item1
    this.operation = operation;
    this.calc_type = OPERATION_TYPE;
    this.output_table = outputTable;
    this.output_column = outputColumn;
  }
}

export class Source {
  constructor(source) {
    this.source = source;
    this.calc_type = SOURCE_TYPE;
  }
}

export class Join {
  constructor(column0, column1) {
    this.column0 = column0;
    this.column1 = column1;
    this.calc_type = JOIN_TYPE;
  }
}

export class SpecialVTTrueUp {
  constructor(source0, source1) {
    this.source0 = source0;
    this.source1 = source1;
    this.calc_type = SPECIAL_VT_TRUE_UP;
  }
}

export function newCalcDetailFromType(calcType, guid) {
  let card = null;
  switch (calcType) {
    case FILTER_TYPE:
      card = new Filter();
      break;
    case AGGREGATE_TYPE:
      card = new Aggregate();
      break;
    case OPERATION_TYPE:
      card = new Operation();
      break;
    case SOURCE_TYPE:
      card = new Source();
      break;
    case JOIN_TYPE:
      card = new Join();
      break;
    case SPECIAL_VT_TRUE_UP:
      card = new SpecialVTTrueUp();
      break;
    default:
      throw 'Unrecognized calc type';
  }
  card.guid = guid === undefined? uuidv4(): guid;
  return card;
}
